package floris.graphics.landing.components.layouts

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import floris.graphics.core.constants.Res
import floris.graphics.core.extensions.format
import com.materialdesignsystem.components.DsPageLayout
import com.materialdesignsystem.toColorScheme
import floris.graphics.landing.components.sections.LandingFooterSection
import floris.graphics.landing.components.sections.LandingHeader
import floris.graphics.landing.components.sections.LandingOverflowMenu

@Composable
fun PageLayout(
    modifier: Modifier = Modifier,
    title: String,
    showMenuItems: Boolean = true,
    footerBackgroundColor: Color = ColorMode.current.toColorScheme.secondaryContainer,
    content: @Composable () -> Unit
) {
    var overflowMenuOpened by remember { mutableStateOf(false) }

    DsPageLayout(
        modifier = modifier,
        title = Res.String.DocumentTitle.format(title),
        header = {
            LandingHeader(showMenuItems) {
                overflowMenuOpened = true
            }
        },
        overflowMenu = {
            LandingOverflowMenu { overflowMenuOpened = false }
        },
        overflowMenuOpened = overflowMenuOpened,
        footer = {
            LandingFooterSection(showMenuItems, Modifier.background(footerBackgroundColor))
        },
        content = content
    )
}